import React from "react";

class ImagesSection extends React.Component {
  render() {
    return (
      <div>
        <strong className="mb-2 d-block">
          {this.props.countryName}'s {this.props.title}
        </strong>
        <img
          style={{width: "100%"}}
          src={this.props.url}
          alt={this.props.title}
        />
      </div>
    );
  }
}

export default ImagesSection;
